import { render, staticRenderFns } from "./DnsManagePanel.vue?vue&type=template&id=1a93a46a&scoped=true&"
import script from "./DnsManagePanel.vue?vue&type=script&lang=ts&"
export * from "./DnsManagePanel.vue?vue&type=script&lang=ts&"
import style0 from "./DnsManagePanel.vue?vue&type=style&index=0&id=1a93a46a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a93a46a",
  null
  
)

export default component.exports